define('adminSettingView',[
    'module',
    'marionette',
    'underscore',
    'app',
    'settings',
    'jqgridView',
    'template!adminSettingListTpl'
], function (
    module,
    Marionette,
    _,
    App,
    Settings,
    JqGridView,
    viewTpl
    ) {
    'use strict';

    var SettingListView = JqGridView.extend({
        template: viewTpl,
        filtersName: 'settingListFilters',

        triggers: {
        },

        ui: function() {
            return _.extend({
                jqGrid: '#jq-grid-list',
                jqGridPager: '#jq-grid-pager-list',
                deleteSetting: '.delete-setting-link'
            }, this.gridUi);
        },

        events: function() {
            return _.extend({
                'click @ui.deleteSetting': 'onDeleteSetting'
            }, this.gridEvents);
        },

        serializeData: function() {
            var templateData = {type: 'setting'};

            return templateData;
        },

        pagination: function() {
            return {
                first: 0,
                rowCount: 0,
                pageSize: Settings.get('perPage15'),
                currentPage: 1
            };
        },

        onDeleteSetting: function(event){
            this.trigger('setting:delete', $(event.currentTarget).find('span').attr('data-row-id'));
        },

        gridOptions: function(data) {
            var options = {
                colModel: [
                    {
                        label: '',
                        name: 'secId',
                        key: true,
                        hidden: true
                    }, {
                        label: _.i18n('setting.sGroup'),
                        name: 'sGroup',
                        classes: 'setting-link',
                        formatter:  this.defaultFormatter,
                        search: false,
                        index: 'sGroup',
                        width: 50
                    }, {
                        label: _.i18n('common.code'),
                        name: 'code',
                        classes: 'setting-link',
                        formatter:  this.defaultFormatter,
                        search: false,
                        index: 'code',
                        width: 50
                    }, {
                        label: _.i18n('setting.params'),
                        name: 'params',
                        classes: 'setting-link',
                        formatter:  this.defaultFormatter,
                        search: false,
                        index: 'params',
                        width: 50
                    }, {
                        label: _.i18n('common.description'),
                        name: 'description',
                        classes: 'setting-link',
                        formatter:  this.defaultFormatter,
                        search: false,
                        index: 'description'
                    }, {
                        label: ' ',
                        name: 'delete',
                        search: false,
                        classes: 'delete-setting-link delete-link',
                        formatter: this.deleteIconFormatter,
                        width: 20
                    }
                ],

                onSelectRow: function(rowId, bool, e) {
                    if (!$(e.target).hasClass('cell-delete') && e.type === 'click') {
                        if (e.type === 'click') {
                            var route = App.getCurrentRoute() ===  'admin/settings' ?
                                App.getCurrentRoute() : 'admin/settings/' + App.getCurrentRoute();
                            App.navigate(route + '/' + rowId, {trigger: true});
                        }
                    }
                }
            };

            options = _.defaults(options, this.gridInitOptions(data));

            return options;
        }
    });

    module.exports = SettingListView;
});
